import { Link } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Shop", path: "/shop" },
  { label: "About", path: "/about" },
  { label: "Journal", path: "/journal" },
  { label: "Challenge", path: "/challenge" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1E2D26] text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/73c9ae7c2fff2d7ff7e65e9a3d8da812/8422d6972a85af9e9191a5ab21aafb82.png"
              alt="10 Pages a Day"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              A lifestyle brand built around a simple habit. Consistency matters more than intensity. Small daily actions shape who we become.
            </p>
            <p className="text-[#6B9E8A] text-sm font-medium mt-4 tracking-wide">Read more. Every day.</p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Explore</h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Philosophy Snippet */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">The Principle</h4>
            <blockquote className="border-l-2 border-[#6B9E8A] pl-4">
              <p className="text-white/60 text-sm leading-relaxed">
                "You don't rise to the level of your goals, you fall to the level of your systems. 10 pages a day is your system."
              </p>
            </blockquote>
            <div className="mt-6 flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded border border-white/20 hover:border-white/60 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded border border-white/20 hover:border-white/60 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded border border-white/20 hover:border-white/60 transition-colors cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-sm" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">&copy; 2026 10 Pages a Day. Read more, live better.</p>
          <div className="flex gap-6">
            <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Privacy</a>
            <a href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
